export default __webpack_public_path__ + "static/media/login-starcircle.53ae06dd.svg";